import { render, staticRenderFns } from "./FAQSection.vue?vue&type=template&id=7dc879e2&"
import script from "./FAQSection.vue?vue&type=script&lang=js&"
export * from "./FAQSection.vue?vue&type=script&lang=js&"
import style0 from "./FAQSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports